export default __webpack_public_path__ + "static/media/Hassle.ad4c0fff.png";